import styled from "styled-components";
import { colors } from "../../styles/colors";

export const Projects = styled.div`
    max-width: 900px;
    margin: 0 auto;
    margin-bottom: 50px;
    padding-top: 100px;
    opacity: 0;

    h3 {
        margin: 0;
    }

    a{
        text-decoration: none;
    }

    @keyframes fadeInProjects {
        from {
            opacity: 0;
            transform: translateY(100%);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 768px) {
        padding-top: 80px;
    }
`

export const Title = styled.h2`
    text-align: center;
    margin: 0 0 70px 0;
    font-size: 30px;
    color: ${colors.TEXT_WHITE};
    font-family: 'Raleway Dots', cursive;
    span{
        font-size: 40px;
        background: #61bdfb;
        -webkit-background-clip: text !important;
        -webkit-text-fill-color: transparent !important;
        font-family: 'Rubik 80s Fade', cursive;
    }
`

export const ContentProjects = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    color: ${colors.TEXT_WHITE};
    @media (max-width: 768px){
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 468px){
        grid-template-columns: repeat(1, 1fr);
    }
`

export const projectContent = styled.div`
    margin: 15px;
    `

export const TitleProject = styled.h3`
    padding: 8px 15px;
    font-weight: 700;
    font-size: 25px;
    text-align: center;
    color: ${colors.TEXT_WHITE};
    background: #61bdfb;
    text-decoration: none;
    `

export const TitleAndImage = styled.div`
    transition: 0.1s;
    margin: 25px 0 0 0;
    opacity: 0.75;
    padding: 0;
    overflow: hidden;
    border-radius: 10px;
    :hover{
        transition: 0.3s;
        transform: scale(1.14);
        opacity: 100;
    }
    
    @media (max-width: 768px){
        transition: none;
        transform: none;
        opacity: 100;
    }
    
    `


export const ContainerImage = styled.div`
    text-align: center;
    img {
        z-index: 1;
        width: 100%;
    }

    @media (max-width: 768px){
        img{
            /* max-width: 250px; */
        }
    }
`

export const ContainerTechs = styled.div`
    display: flex;
    align-items: center;
    padding-top: 10px;
    justify-content: space-evenly;
    font-size: 2px;
    
    div{
        text-align: center;
        width: 30%;
        height: 80px;
    }
    
    img {
        width: 35px;
        height: auto;
        margin: 0 5px;
    }

    p{
        margin-top: 2px;
        font-size: 13px;
        color: ${colors.TEXT_WHITE};
    }

    @media (max-width: 768px) {
        padding-top: 0;

        div {
            width: 25%;
            height: auto;
            margin: 10px 0;
        }
        img {
            width: 30px;
        }
        p {
            font-size: 9px;
        }
    }
`

export const Description = styled.div`
    margin-top: 0;
    font-size: 16px;
`

export const ContainerFooter = styled.div`
    display: flex;
    align-items: center;
    /* border-style: solid; */
    margin-top: 10px;
    img{
        width: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    a:first-of-type {
        padding: 0 20px;
    }

    @media (max-width: 340px){
        img {
            
        }
    }
`